<template>
	<div class="view-container">
		<div class="refresh-btn" @click="onRefresh">刷新</div>
		<div class="health-check-label-header">项目一</div>
		<div class="health-check-label" :style="getUpdateTimeStyle(revReport)">更新时间：{{ revReport?.createTimeString }}</div>
		<div class="health-check-label">测试节点：{{ revReport?.testerLabel }}</div>
		<div class="health-check-label">测试结果：</div>
		<template v-for="item in revReport?.result" :key="item.url">
			<div class="test-result-item" :style="getTestResultStyle(item)">{{ item.url }},
				code: {{ item.statusCode }}, tag: {{item.tag}}
			</div>
		</template>
		<div class="health-check-label-header">项目二</div>
		<div class="health-check-label" :style="getUpdateTimeStyle(airportReport)">更新时间：{{ airportReport?.createTimeString }}</div>
		<div class="health-check-label">测试节点：{{ airportReport?.testerLabel }}</div>
		<div class="health-check-label">测试结果：</div>
		<template v-for="item in airportReport?.result" :key="item.url">
			<div class="test-result-item" :style="getTestResultStyle(item)">{{ item.url }},
				{{ item.statusCode }}
			</div>
		</template>
		<div class="health-check-label-header">文件服务器Endpoint</div>
		<div class="health-check-label" :style="getUpdateTimeStyle(fileServerEndpointReport)">更新时间：{{ fileServerEndpointReport?.createTimeString }}</div>
		<div class="health-check-label">测试节点：{{ fileServerEndpointReport?.testerLabel }}</div>
		<div class="health-check-label">测试结果：</div>
		<template v-for="item in fileServerEndpointReport?.result" :key="item.url">
			<div class="test-result-item" :style="getTestResultStyle(item)">{{ item.url }},
				code: {{ item.statusCode }}, tag: {{ item.tag }}
			</div>
		</template>
		<div class="health-check-label-header">营销网站</div>
		<div class="health-check-label" :style="getUpdateTimeStyle(marketingReport)">更新时间：{{ marketingReport?.createTimeString }}</div>
		<div class="health-check-label">测试节点：{{ marketingReport?.testerLabel }}</div>
		<div class="health-check-label">测试结果：</div>
		<template v-for="item in marketingReport?.result" :key="item.url">
			<div class="test-result-item" :style="getTestResultStyle(item)">{{ item.url }},
				code: {{ item.statusCode }}, tag: {{ item.tag }}
			</div>
		</template>
		<div class="health-check-label-header">官方网站</div>
		<div class="health-check-label" :style="getUpdateTimeStyle(officialSiteReport)">更新时间：{{ officialSiteReport?.createTimeString }}</div>
		<div class="health-check-label">测试节点：{{ officialSiteReport?.testerLabel }}</div>
		<div class="health-check-label">测试结果：</div>
		<template v-for="item in officialSiteReport?.result" :key="item.url">
			<div class="test-result-item" :style="getTestResultStyle(item)">{{ item.url }},
				code: {{ item.statusCode }}, tag: {{ item.tag }}
			</div>
		</template>
	</div>

</template>
<script >
import {getRequestAsync, hideLoading, showLoading} from "@/utils/methods";

export default {
	name: "ServerInfoView",
	components: {},
	data() {
		return {
			revReport: null,
			airportReport: null,
			fileServerEndpointReport: null,
			marketingReport: null,
			officialSiteReport: null,
		}
	},
	async mounted() {
		await this.fetchAllReports()
	},
	methods: {
		async fetchAllReports() {
			showLoading()
			try {
				const result = await getRequestAsync('admin/stats/getAllTestReports')
				if (result?.code === 200 && result?.msg) {
					this.revReport = result.msg.revReport
					this.airportReport = result.msg.airportReport
					this.fileServerEndpointReport = result.msg.fileServerEndpointReport
					this.marketingReport = result.msg.marketingReport
					this.officialSiteReport = result.msg.officialSiteReport
				}
			} finally {
				hideLoading()
			}
		},
		getTestResultStyle(item) {
			return {
				color: item.statusCode === 200 ? 'green' : 'red'
			}
		},
		getUpdateTimeStyle(report) {
			if (!report?.createTimestamp) {
				return {}
			}
			const nowSec = Math.floor(Date.now() / 1000)
			const isStale = nowSec - report.createTimestamp > 30 * 60
			return isStale ? {color: 'red'} : {}
		},
		async onRefresh() {
			await this.fetchAllReports()
		}
	}
}
</script>
<style scoped>
.view-container {
	background-color: #191123;
	width: 100vw;
	height: 100vh;
	display: flex;
	flex-direction: column;
	padding: 0.4em;
	box-sizing: border-box;
	align-items: start;
	overflow-x: hidden;
	overflow-y: auto;
}

.health-check-label {

	color: #E6D5B8;
	font-size: 1em;
	word-break: keep-all;
}

.health-check-label-header{
	color: #E6D5B8;
	font-size: 1em;
	font-weight: bold;
	margin-top: 0.4em;
}

.test-result-item {
	width: 100%;
	box-sizing: border-box;
	font-size: 1em;
	text-align: start;
	word-break: break-all;
}

.refresh-btn {
	color: #E6D5B8;
	border: 1px solid #E6D5B8;
	padding: 0.2em 0.4em;
	font-size: 1.2em;
	line-height: 1em;
	height: fit-content;
	border-radius: 0.2em;
	cursor: pointer;
	margin-bottom: 0.4em;
}

</style>